import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

export function useNotesRollup(hid, enabled = true) {
  const [rollup, setRollup] = useState(null);
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!enabled || !hid) {
      setRollup(null);
      setNotes([]);
      setLoading(false);
      setError("");
      return;
    }

    let cancelled = false;

    setLoading(true);
    setError("");

    api.get(`/notes?household_id=${encodeURIComponent(hid)}`)
      .then((res) => {
        if (cancelled) return;
        const data = res.data || {};
        setRollup(data.rollup || null);
        setNotes(Array.isArray(data.notes) ? data.notes : []);
      })
      .catch((e) => {
        if (cancelled) return;
        setRollup(null);
        setNotes([]);
        const detail = e?.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "Failed to load notes rollup.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [enabled, hid]);

  const byLoanId = useMemo(() => {
    const map = new Map();
    notes.forEach((note) => {
      const id = note?.id;
      if (id === null || id === undefined || typeof id === "object") return;
      map.set(id, note);
      map.set(String(id), note);
    });
    return map;
  }, [notes]);

  return { byLoanId, rollup, loading, error };
}
